import { NextSeo } from 'next-seo';
import PackagePage from '_components/composed/pages/PackagePage';

export default function Package() {
  return (
    <>
      <NextSeo title="Register Your LLC, S-Corp, C-Corp, or Nonprofit | Incorpified" />
      <PackagePage />
    </>
  );
}
